<template>
  <tbody>
  <tr :class="[{'more_info': $_updateActionAllowed}, {disabled: entity.deleted}, { open: isOpen }]" @click="toggleMoreInfo()">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <input type="checkbox"
                 :id="'pvvCheckbox'+entity.id"
                 :value="entity.id"
                 @change="onChange"
                 :checked="isChecked"
                 @click.stop
          />
          <label :for="'pvvCheckbox'+entity.id" @click.stop v-translate>Vybrat</label>
        </td>
      <td class="first_data" data-th="Název">
        <strong ><entity-link v-if="entity.name" :id="entity.id_vod_video" type="vodVideo">{{ entity.name }}</entity-link></strong>
        <span class="stitek stitek--ad" v-if="!entity.deleted && !entity.available" v-translate>Nedostupné!</span>
      </td>
        <td data-th="Cena">{{entity.price }}</td>
        <td data-th="Zařízení">
          <entity-link v-if="entity.device_name" :id="entity.id_device" type="device">{{ entity.device_name }}</entity-link>
        </td>
        <td data-th="Profil">
          <entity-link v-if="entity.subscriber_profile_name" :id="entity.id_subscriber_profile" type="subscriberProfile">{{ entity.subscriber_profile_name }}</entity-link>
        </td>
        <td data-th="Typ zakoupení">{{purchaseType }}</td>
        <td data-th="Typ zakoupení">{{ note }}</td>
        <td data-th="Čas zakoupení" v-html="$_date_formatFull(entity.purchase_timestamp)"></td>
        <td class="no_padding edit">
          <div class="edit_inner">
            <a v-if="$_updateActionAllowed && !entity.deleted" class="btn btn_action btn_delete" @click.stop="onDeletePurchasedVideo" :title="$gettext('Smazat')">{{ $gettext('Smazat') }}</a>
          </div>
        </td>
    </tr>
  <tr v-if="$_updateActionAllowed" :class="['more_info_content', { open: isOpen }]">
    <td colspan="4"></td>
    <td colspan="3">
      <textarea-input
          :id="'purchased_video_note-'+entity.id"
          v-model="entity.note">
        <translate class="translate">Poznámka</translate>
      </textarea-input>
    </td>
    <td></td>

    <td><p>
      <input
          class="btn"
          type="submit"
          :value="'Uložit' | translate"
          @click.stop.prevent="emitUpdateNote">
    </p></td>
    <td class="first_data"><p></p></td>
  </tr>
  </tbody>
</template>

<script>
import EntityLink from "../../../common/EntityLink.vue";
import {textShortener} from "../../../../utils/helpers";

export default {
		name: "entityRow",
    components: { EntityLink },
		props: {
			entity: Object,
      selectedEntities: Array,
      vodDetailAllowed: Boolean,
		},
    data() {
      return {
        isOpen: false,
      }
    },
        methods: {
          onDeletePurchasedVideo() {
            this.$emit('deletePurchasedVod', this.entity.id);
          },
          toggleMoreInfo() {
            if (this.$_updateActionAllowed) {
              this.isOpen = !this.isOpen
            }
          },
          onChange: function (e) {
            this.$emit('input', e)
          },
          emitUpdateNote() {
            let data = {
                id_video: this.entity.id,
                note: this.entity.note
            };
            this.$emit('updatePurchasedVideo', data)
            this.isOpen = false;
          },
        },
        computed: {
          isChecked() {
            return this.selectedEntities.indexOf(String(this.entity.id)) > -1
          },
          purchaseType() {
            switch (this.entity.purchase_type){
              case "DEVICE":
                return this.$gettext("Zařízení");
              case "OPERATOR":
                return this.$gettext("Operátor");
              default:
                return this.$gettext("Neznámý");
            }
          },
          note(){
            return textShortener(this.entity.note, 100);
          }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/purchasedVodVideos/PurchasedVodVideosRow.vue